import { useQueries } from "@tanstack/react-query";
import { getEvidenceData } from "@/features/reports/api/reportApi";

export interface FailedVideoLabel {
  id: string;
  /** The video's friendly title, or the raw id while loading / on lookup
   *  failure (the deleted-evidence case shouldn't blank the prompt). */
  label: string;
}

/**
 * Resolves each failed-transcription video id to a friendly title via
 * GET /evidence/details. The id itself is the fallback label so the prompt
 * always names something, even before titles load or if a lookup 404s.
 */
export function useFailedVideoTitles(videoIds: string[]): FailedVideoLabel[] {
  return useQueries({
    queries: videoIds.map((id) => ({
      queryKey: ["evidence", id] as const,
      queryFn: () => getEvidenceData(id),
      // Stable metadata; let it ride the cache other surfaces already warm.
      staleTime: 5 * 60 * 1000,
      retry: false,
    })),
    combine: (results) =>
      results.map((result, index) => ({
        id: videoIds[index],
        label: result.data?.title?.trim() || videoIds[index],
      })),
  });
}
